import { AppSource } from 'types/AppSource'

type Input = AppSource

export const getUrlWithAppSource = ({
  sourceDetails,
  sourceType,
  url,
}: Input) => {
  try {
    const urlWithAppSource = new URL(url)

    urlWithAppSource.searchParams.set(
      'appSource',
      JSON.stringify({
        sourceDetails,
        sourceType,
        timestamp: new Date().toISOString(),
      }),
    )

    return urlWithAppSource.toString()
  }
  catch {
    return url
  }
}
